import React from 'react';
import { useTheme } from '../hooks/useTheme';
import { useTranslation } from 'react-i18next';

export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <button
      className="btn btn-link nav-link"
      onClick={toggleTheme}
      aria-label={t('theme.switch_to', 'Switch to {{theme}} theme', { theme: isDark ? t('theme.light', 'light') : t('theme.dark', 'dark') })}
      title={t('theme.switch_to', 'Switch to {{theme}} theme', { theme: isDark ? t('theme.light', 'light') : t('theme.dark', 'dark') })}
    >
      <i className={`bi ${isDark ? 'bi-sun' : 'bi-moon'}`} aria-hidden="true"></i>
    </button>
  );
}
